<template>
    <v-row>
        <v-col class="py-0" cols="6">
            <h1>{{parametros && parametros.FAT_TIPO_TITULO? "Notas fiscais e títulos": "Notas fiscais"}}</h1>
            <p>Gerencie as notas fiscais{{ parametros && parametros.FAT_TIPO_TITULO? " e títulos associados": " associadas " }} ao cronograma.</p>
        </v-col>
        <v-col class="text-end py-0" cols="6">
            <v-btn
                v-if="userData.PermissaoAcoes.faturamento.includes('addnotafiscal') && !(disableAssociarLote && cronograma.complementar) && !(parameter.status=='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && !cronograma.complementar)"
                outlined
                small
                height="30px"
                color="primary"
                depressed
                @click="getNotas()"
            >Adicionar documento fiscal</v-btn>
            <v-tooltip v-else-if="(parameter.status=='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && !cronograma.complementar)" center bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                outlined
                color="rgb(151 151 151 / 58%)"
                small
                height="30px"
                depressed
                v-bind="attrs"
                v-on="on"
                >Adicionar documento fiscal</v-btn>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
               Não é possível adicionar nota após a conclusão de um cronograma com obrigatoriedade de nota fiscal.
            </span>
            </v-tooltip>
            <v-tooltip v-else-if="disableAssociarLote && cronograma.complementar" center bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                outlined
                color="rgb(151 151 151 / 58%)"
                small
                height="30px"
                depressed
                v-bind="attrs"
                v-on="on"
                >Adicionar documento fiscal</v-btn>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
               Não é possível adicionar nota fiscal pois não existem lotes válidos para associá-la.
            </span>
            </v-tooltip>
            <v-tooltip v-else center bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                outlined
                color="rgb(151 151 151 / 58%)"
                small
                height="30px"
                depressed
                v-bind="attrs"
                v-on="on"
                >Adicionar documento fiscal</v-btn>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                Você não possui permissão para executar esta ação.
            </span>
            </v-tooltip>
        </v-col>

        <v-tabs v-model="tab" dense class="elevation-0 px-0">
            <v-tab  @click="getListFiltradaLocal()">{{parametros && parametros.FAT_TIPO_TITULO? "Notas Fiscais e títulos Associados": "Notas Fiscais Associadas"}}</v-tab> 
            <v-tab >{{parametros && parametros.FAT_TIPO_TITULO? "Buscar Notas Fiscais e títulos" : "Buscar Notas Fiscais"}}</v-tab>
            <v-tabs-items v-model="tab" class="px-3">
                <v-tab-item>
                    <v-col class="pt-0 pb-3" cols="12">
                        <CronogramaInfo v-if="cronograma.complementar" :info="cronograma"/>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="search"
                            placeholder="Filtrar por número"
                            single-line
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col id="table-notas" cols="12">
                        <v-data-table
                            dense
                            hide-default-footer
                            :headers="headers"
                            :items="listCorr"
                            :search="search"
                            :items-per-page="itemsPerPage"
                            :page.sync="page"
                            @page-count="pageCount = parseInt($event, itemsPerPage)"
                        >
                            <template v-slot:item.tipo="{ item }" class="text-center pa-2">
                                <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-if="item.tipo == 1"
                                            small
                                            color="primary"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            fa-file-invoice-dollar
                                        </v-icon>
                                        <v-icon
                                        v-else
                                            small
                                            color="primary"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            fa-money-check
                                        </v-icon>
                                        </template>
                                        <span v-if="item.tipo == 1" class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">Nota</span>
                                        <span v-else class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">Título</span>
                                    </v-tooltip>
                            </template>
                            <template v-slot:item.numero="{ item }" class="text-center pa-2">
                                {{ item.numero == null || item.numero == "" ? item.nr_titulo : item.numero }}
                            </template>
                            <template v-slot:item.data_venc_titulo="{ item }" class="text-center pa-2">
                                {{ item.data_venc_titulo | formatDate }}
                                
                            </template>
                            <template v-slot:item.dt_emissao="{ item }" class="text-center pa-2">
                                {{ item.dt_emissao | formatDate }}
                            </template>
                            <template v-slot:item.data_venc_titulo="{ item }" class="text-center pa-2">
                                {{ item.data_venc_titulo | formatDate }}
                            </template>
                            <template v-slot:item.valor="{ item }" class="text-center pa-2">
                                {{ item.valor | formatPrice }}
                            </template>
                            <template v-slot:item.cnpj="{ item }" class="text-center pa-2">
                                 {{item.cnpj | formatCnpj }}
                            </template>
                            <template v-slot:item.link="{ item }" class="text-center pa-2">
                                <a style="color:#118ACA;cursor:pointer" :href="item.link" target="_blank">{{ item.link }}</a>
                            </template>
                            <template v-slot:item.lotes="{ item }" class="text-center pa-2">
                                {{ item.lotes }} 
                                <v-btn :disabled="(parameter.status=='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && !cronograma.complementar) || (cronograma.complementar && disableAssociarLote)" v-if="!item.integrada && !disableAssociarLote" small color="primary lighten-2" icon>
                                    <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updatenotafiscal')" @click="assocItem(item)" small>fa-plus</v-icon>
                                    <v-icon v-else @click="userInfo()" small>fa-plus</v-icon>
                                </v-btn>
                                
                                <v-tooltip v-else center bottom>
                                    <!-- -if="parameter.status!='F'"  -->
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="#94999C"
                                        small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    ><v-icon small>fa-plus</v-icon>
                                    </v-btn>
                                    </template>
                                    <span class="pa-5"> {{disableAssociarLote? 'Não existem lotes válidos para integrar' :'Nota fiscal já integrada com a operadora'}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.doc_id="{ item }" class="text-center pa-2">
                                    <v-tooltip bottom v-if="item.doc_id">
                                    <template v-slot:activator="{ on, attrs }" >
                                        <span v-bind="attrs" v-on="on" class="pa-0">
                                            <v-btn small color="primary lighten-2" icon @click="getFile({doc_id: item.doc_id, nome: item.anexo})">
                                                <v-icon small>fa-download</v-icon>
                                            </v-btn>
                                        </span>
                                    </template>
                                    <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">
                                        {{item.anexo}}
                                    </span>
                                    </v-tooltip>
                            </template>
                            <template v-slot:item.editar="{ item }" class="text-center pa-2">
                                <v-btn :disabled="parameter.status=='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO" v-if="!item.integrada" small color="primary lighten-2" icon>
                                    <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updatenotafiscal')" @click="getNotas(item.id)" small>fa-pencil-alt</v-icon>
                                    <v-icon v-else @click="userInfo()" small>fa-pencil-alt</v-icon>
                                </v-btn> 
                                <v-tooltip v-else center bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :disabled="!!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && parameter.status=='F'"
                                        color="#94999C"
                                        x-small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    ><v-icon small>fa-pencil-alt</v-icon>
                                    </v-btn>
                                    </template>
                                    <span class="pa-5">Nota fiscal já integrada com a operadora</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:item.excluir="{ item }" class="text-center pa-2">
                                
                                <v-btn :disabled="!!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && parameter.status=='F'" v-if="item.lotes==0 && item.integrada==0" small color="primary lighten-2" icon>
                                    <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('deletenotafiscal')" @click="delItem(item)" small>mdi-delete</v-icon>
                                    <v-icon v-else @click="userInfo()" small>mdi-delete</v-icon>
                                    
                                </v-btn>

                                <v-tooltip v-else center bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :disabled="!!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && parameter.status=='F'"
                                        color="#94999C"
                                        small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    ><v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                    </template>
                                    <span class="pa-5">{{item.integrada?'Nota fiscal já integrada com a operadora': 'Esta nota fiscal possui lotes associados'}}</span>
                                </v-tooltip>
                            </template>
                            </v-data-table>
                    </v-col>
                    <v-col class="text-center py-0" cols="12">
                        <v-pagination
                            class="no-box-shadow"
                            v-model="page"
                            :length="pageCount"
                        ></v-pagination>
                    </v-col>
                </v-tab-item>

                <v-tab-item>
                    <FiltroBusca
                        class="pb-0"
                        :filtrarDoc="(formFiltro) => getListFiltradaLocal(formFiltro, true)"
                        :parametros="parametros"
                        :limpar="() => limparList()"
                        :limpaFiltros="mudarTab"
                    />

                    <v-col id="table-notas-filtro" cols="12" class="px-0 pt-0">
                        <v-data-table
                            dense
                            hide-default-footer
                            :headers="headersF"
                            :items="listFil"
                            :items-per-page="itemsPerPageF"
                            :page.sync="pageF"
                            @page-count="pageCountF = parseInt($event, itemsPerPageF)"
                        >
                        

                        <template v-slot:item.tipo="{ item }" class="text-center pa-2">
                            
                                <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-if="item.tipo == 1"
                                            small
                                            color="primary"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            fa-file-invoice-dollar
                                        </v-icon>
                                        <v-icon
                                        v-else
                                            small
                                            color="primary"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            fa-money-check
                                        </v-icon>
                                        </template>
                                        <span v-if="item.tipo == 1" class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">Nota</span>
                                        <span v-else class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">Título</span>
                                    </v-tooltip>
                                    
                            </template>
                            <template v-slot:item.numero="{ item }" class="text-center pa-2">
                                {{ item.numero == null || item.numero == "" ? item.nr_titulo : item.numero }}
                            </template>
                            <template v-slot:item.data_venc_titulo="{ item }" class="text-center pa-2">
                                {{ item.data_venc_titulo | formatDate }}
                            </template>
                            <template v-slot:item.cnpj="{ item }" class="text-center pa-2">
                                 {{item.cnpj | formatCnpj }}
                            </template>
                            <template v-slot:item.dt_emissao="{ item }" class="text-center pa-2">
                                {{ item.dt_emissao | formatDate }}
                            </template>
                            <template v-slot:item.data_venc_titulo="{ item }" class="text-center pa-2">
                                {{ item.data_venc_titulo | formatDate }}
                            </template>
                            <template v-slot:item.valor="{ item }" class="text-center pa-2">
                                {{ item.valor | formatPrice }}
                            </template>
                            <template v-slot:item.link="{ item }" class="text-center pa-2">
                                <a style="color:#118ACA;cursor:pointer" :href="item.link" target="_blank">{{ item.link }}</a>
                            </template>
                            <template v-slot:item.lotes="{ item }" class="text-center pa-2">
                                {{ item.lotes }} 
                                <v-btn :disabled="(parameter.status=='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && !cronograma.complementar) || (cronograma.complementar && disableAssociarLote)" v-if="!item.integrada && !disableAssociarLote" small color="primary lighten-2" icon>
                                    <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updatenotafiscal')" @click="assocItem(item)" small>fa-plus</v-icon>
                                    <v-icon v-else @click="userInfo()" small>fa-plus</v-icon>
                                </v-btn>
                                
                                <v-tooltip v-else center bottom>
                                    <!-- -if="parameter.status!='F'"  -->
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="#94999C"
                                        small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    ><v-icon small>fa-plus</v-icon>
                                    </v-btn>
                                    </template>
                                    <span class="pa-5"> {{disableAssociarLote? 'Não existem lotes válidos para integrar' :'Nota fiscal já integrada com a operadora'}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.doc_id="{ item }" class="text-center pa-2">
                                    <v-tooltip bottom v-if="item.doc_id">
                                    <template v-slot:activator="{ on, attrs }" >
                                        <span v-bind="attrs" v-on="on" class="pa-0">
                                            <v-btn small color="primary lighten-2" icon @click="getFile({doc_id: item.doc_id, nome: item.anexo})">
                                                <v-icon small>fa-download</v-icon>
                                            </v-btn>
                                        </span>
                                    </template>
                                    <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">
                                        {{item.anexo}}
                                    </span>
                                    </v-tooltip>
                            </template>
                            <template v-slot:item.editar="{ item }" class="text-center pa-2">
                                <v-btn :disabled="parameter.status=='F' && !!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO" v-if="!item.integrada" small color="primary lighten-2" icon>
                                    <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updatenotafiscal')" @click="getNotas(item.id)" small>fa-pencil-alt</v-icon>
                                    <v-icon v-else @click="userInfo()" small>fa-pencil-alt</v-icon>
                                </v-btn> 
                                <v-tooltip v-else center bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :disabled="!!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && parameter.status=='F'"
                                        color="#94999C"
                                        x-small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    ><v-icon small>fa-pencil-alt</v-icon>
                                    </v-btn>
                                    </template>
                                    <span class="pa-5">Nota fiscal já integrada com a operadora</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:item.excluir="{ item }" class="text-center pa-2">
                                
                                <v-btn :disabled="!!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && parameter.status=='F'" v-if="item.lotes==0 && item.integrada==0" small color="primary lighten-2" icon>
                                    <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('deletenotafiscal')" @click="delItem(item,filtroDtT, 1)" small>mdi-delete</v-icon>
                                    <v-icon v-else @click="userInfo()" small>mdi-delete</v-icon>
                                    
                                </v-btn>

                                <v-tooltip v-else center bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :disabled="!!parameter.config && parameter.config.FAT_NOTA_FISCAL_OBRIGATORIO && parameter.status=='F'"
                                        color="#94999C"
                                        small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    ><v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                    </template>
                                    <span class="pa-5">{{item.integrada?'Nota fiscal já integrada com a operadora': 'Esta nota fiscal possui lotes associados'}}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col class="text-center py-0" cols="12">
                        <v-pagination
                            class="no-box-shadow"
                            v-model="pageF"
                            :length="pageCountF"
                        ></v-pagination>
                    </v-col> 
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </v-row>
</template>

<script>
import moment from 'moment'
import CronogramaInfo from './CronogramaInfo'
import FiltroBusca from './FiltroBusca.vue'
export default {
    components: {
        CronogramaInfo, 
        FiltroBusca
    },
    props: {
        userData: Object,
        parameter: Object, // Parâmetros gravados no config do cronograma
        cronograma: Object,
        list: Array,
        delItem: Function,
        getNotas: Function,
        assocItem: Function,
        getFile: Function,
        disableAssociarLote: Boolean,
        getListFiltrada: Function,
        listFiltrada: Array,
        parametros: Object, // Parâmetros do config Prestador/Operadora
        fechado: Boolean
    },
    mounted(){
        if(this.parametros && this.parametros.FAT_TIPO_TITULO){
            this.headers = [
                    { text: "Tipo", value: "tipo", align: "center", sortable: false, 'filterable':false },
                    { text: "Número", align: "center", value: "numero", sortable: false, 'filterable':true },
                    { text: "CNPJ", value: "cnpj", align: "center", sortable: false, 'filterable':false },
                    { text: "Venc. Título", align: "center", value: "data_venc_titulo", sortable: false, 'filterable':false },
                    { text: "Emissão Nota", align: "center", value: "dt_emissao", sortable: false, 'filterable':false },
                    { text: "Valor (R$)", value: "valor", align: "right", sortable: false, 'filterable':false },
                    { text: "Link", value: "link", sortable: false, 'filterable':false },
                    { text: "Lotes assoc.", value: "lotes", align: "right", sortable: false, 'filterable':false  },
                    { text: "Baixar", value: "doc_id", sortable: false, 'filterable':false  },
                    { text: "Editar", value: "editar", align: "center", sortable: false, 'filterable':false  },
                    { text: "Excluir", value: "excluir", align: "center", sortable: false, 'filterable':false  },
                ]
            }
    },
    watch: {
        list:{
            handler(val){
                if(this.mudarTab){
                    this.tab = val.length == 0 ?  1 :  0
                }
            },
            deep: true
        },
        tab:{
            handler(val){
                if(val == 1) {
                    this.mudarTab = false
                }
            },
            deep: true
        },
        fechado:{
            handler(val){
                if(val) {
                    this.mudarTab = true
                }
            },
            deep: true
        },
    },
    data() {
        return {
            headers: [
                    { text: "Tipo", value: "tipo", align: "center", sortable: false, 'filterable':false },
                    { text: "Número", align: "center", value: "numero", sortable: false, 'filterable':true },
                    { text: "CNPJ", value: "cnpj", align: "center", sortable: false, 'filterable':false },
                    { text: "Emissão Nota", align: "center", value: "dt_emissao", sortable: false, 'filterable':false },
                    { text: "Valor (R$)", value: "valor", align: "right", sortable: false, 'filterable':false },
                    { text: "Link", value: "link", sortable: false, 'filterable':false },
                    { text: "Lotes assoc.", value: "lotes", align: "right", sortable: false, 'filterable':false  },
                    { text: "Baixar", value: "doc_id", sortable: false, 'filterable':false  },
                    { text: "Editar", value: "editar", align: "center", sortable: false, 'filterable':false  },
                    { text: "Excluir", value: "excluir", align: "center", sortable: false, 'filterable':false  },
                ],
            headersF: [
                    { text: "Tipo", value: "tipo", align: "center", sortable: false, 'filterable':false },
                    { text: "Número", align: "center", value: "numero", sortable: false, 'filterable':true },
                    { text: "CNPJ", value: "cnpj", align: "center", sortable: false, 'filterable':false },
                    { text: "Emissão Nota", align: "center", value: "dt_emissao", sortable: false, 'filterable':false },
                    { text: "Valor (R$)", value: "valor", align: "right", sortable: false, 'filterable':false },
                    { text: "Link", value: "link", sortable: false, 'filterable':false },
                    { text: "Lotes assoc.", value: "lotes", align: "right", sortable: false, 'filterable':false  },
                    { text: "Baixar", value: "doc_id", sortable: false, 'filterable':false  },
                    { text: "Editar", value: "editar", align: "center", sortable: false, 'filterable':false  },
                    { text: "Excluir", value: "excluir", align: "center", sortable: false, 'filterable':false  },
                ],
            showParam: false,
            mudarTab: true,
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            pageF: 1,
            pageCountF: 0,
            itemsPerPageF: 10,
            search: '',
            tab: 0,
            tipoH: null,
            filtroDtT: {}
        }
    },
    filters: {
        formatDate(date) {
            let retorno = moment(date).format("L")
            if(retorno == 'Data inválida' || retorno == '01/01/0001') return ''
            else return moment(date).format("L");
        },
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },
    computed: {
        listFil: function() {
            return this.listFiltrada
        },
        listCorr: function(){
            
            this.list.forEach((ele) => { 
                ele.numero == null || ele.numero == '' ? ele.numero = ele.nr_titulo : undefined 
            })
            
            let listAux =  this.list
            // Serão exibidos as notas criadas no próprio cronogramasmesmo que não possua lote associado
            // this.list.filter((ele) => {return ele.lotes != 0})
            
            return listAux
        }
    },
    methods: {
        userInfo() {
            let paramModal = {
                type: "error",
                title: "Atenção!",
                message: "Você não possui permissão para executar esta ação. <br/> Contacte o seu gestor.",
                callback: null,
                btConfirm: { name: "Fechar", show: true },
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        },
        getListFiltradaLocal(form, nao_associadas) {
            
            if(nao_associadas) {
                delete form.cronograma_id;
            }
            this.filtroDtT = form
            this.getListFiltrada(form)

            if(form == undefined || form.tipo == null && this.parametros.FAT_TIPO_TITULO) {
                this.tipoH = null
                this.headersF = this.headers
            }

            else if(form.tipo == '1'){
                this.tipoH = 1
                this.headersF = this.headers.filter((ele) => (ele.value != 'data_venc_titulo'))
            }

            else if(form.tipo == '2'){
                this.tipoH = 2
                this.headersF = this.headers.filter((ele) => (ele.value != 'dt_emissao'))
            }

            this.$nextTick()       
        },
        limparList(){
            this.listFiltrada = []
            this.$nextTick()
        }
    },
}
</script>

<style>
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
#table-notas
.v-data-table {
  max-height: 34vh;
  overflow-y: scroll;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

#table-notas-filtro
.v-data-table {
  max-height: 34vh;
  overflow-y: scroll;
  overflow-x: hidden;
  overscroll-behavior: contain;
}



</style>